module.exports = __webpack_public_path__ + "img/page09.947522e2.gif";